import { render, staticRenderFns } from "./RosterLeaves.vue?vue&type=template&id=22daa65f"
import script from "./RosterLeaves.vue?vue&type=script&lang=js"
export * from "./RosterLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports